import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import {
  DxiColumnComponent,
  DxiValidationRuleComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import CustomStore from 'devextreme/data/custom_store';
import { firstValueFrom } from 'rxjs';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { DistributoriService } from 'src/app/shared/services/distributori.service';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';

@Component({
  selector: 'app-distributori',
  templateUrl: './distributori.component.html',
  imports: [
    DxDataGridComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxiColumnComponent,
    DxiValidationRuleComponent,
    DxoExportComponent,
  ],
  standalone: true,
})
export class DistributoriComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private distributoriService = inject(DistributoriService);
  dataSource: any;

  onUpdating(e: any) {
    e.newData = Object.assign(e.oldData, e.newData);
  }

  ngOnInit() {
    this.loadDataSource();
  }

  loadDataSource() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(this.distributoriService.list())
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      insert: (values) => {
        return firstValueFrom(this.distributoriService.insert(values))
          .then((res) => {
            this.distributoriService.listTemp(true).subscribe();
            return res;
          })
          .catch((error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Insert failed';
            }
          });
      },
      remove: (values) => {
        console.log(values);
        return (
          firstValueFrom(this.distributoriService.remove(values))
            //.catch(() => { throw 'Deletion failed' });
            .then(() => {
              console.log('delete eseguito');
              this.distributoriService.listTemp(true).subscribe();
            })
            .catch((error: HttpErrorResponse) => {
              if (error.status == 500) {
                throw error.error.title;
              } else {
                throw 'Deletion failed';
              }
            })
        );
      },
      update: (key, values) => {
        return firstValueFrom(this.distributoriService.update(key, values))
          .then(() => {
            this.distributoriService.listTemp(true).subscribe();
          })
          .catch((error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Update failed';
            }
          });
      },
    });
  }

  onExporting(e: any) {
    GridExportExcel(e, 'Distributori', 'Distributori.xlsx');
  }
}
